import React, { FC } from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

/**
 * Replaces a PayPal panel whose data failed to load. Rendering the panel with its empty defaults
 * instead would read as "no account assigned", and an assignment made from that view would
 * silently replace one the operator never saw.
 */
export const PayPalLoadError: FC<{
  message: string;
  onRetry: () => void;
}> = ({ message, onRetry }) => (
  <Alert
    severity="error"
    action={
      <Button color="inherit" size="small" onClick={onRetry}>
        Retry
      </Button>
    }
  >
    {message}
  </Alert>
);
